import { Component, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { SidebarComponent } from './components/sidebar/sidebar';
import { HeaderComponent } from './components/header/header';
import { SidebarService } from './services/sidebar.service';
import { AuthService } from './services/auth.service';
import { ThemeService } from './services/theme.service';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SidebarComponent, HeaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected sidebarService = inject(SidebarService);
  protected authService = inject(AuthService);
  private themeService = inject(ThemeService); // Initialized here to ensure theme is set on startup
  private swUpdate = inject(SwUpdate);
  private router = inject(Router);

  protected isPublicRoute = signal<boolean>(
    typeof window !== 'undefined' && window.location.pathname.startsWith('/public/')
  );

  constructor() {
    this.setupUpdateActivation();
    this.router.events
      .pipe(filter((evt): evt is NavigationEnd => evt instanceof NavigationEnd))
      .subscribe((evt) => {
        const url = evt.urlAfterRedirects || evt.url || '';
        this.isPublicRoute.set(url.startsWith('/public/'));
      });
  }

  private setupUpdateActivation() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
        .subscribe(() => {
          if (confirm('새 버전을 사용할 수 있습니다. 지금 업데이트하시겠습니까?')) {
            window.location.reload();
          }
        });
    }
  }
}
